"use client";
import { FC, useEffect, useState } from "react";
import { useAppStore, selectUser } from "@/store/appStore";
import React from "react";
import { LoaderCircle } from "lucide-react";
import { usePathname } from "next/navigation";
import clsx from "clsx";
import classes from "./page.module.css";
import { Transactions } from "../../transactions";
import { Invoices } from "../../invoices";
import { Statements } from "../../statements";
import { Accounts } from "../../accounts";
import { Reports } from "../../reports";
import { Uploads } from "../../uploads";
import { UserExtended } from "@/types";

export default function Page() {
  const [loading, setLoading] = useState(true);
  const [initializedRoutes, setInitializedRoutes] = useState<string[]>([]);
  const user: UserExtended | null = useAppStore(selectUser);
  const pathname = usePathname();
  const queryPathname = pathname === "/" ? "/transactions" : pathname;

  // Mark the current route as initialized
  useEffect(() => {
    if (!initializedRoutes.includes(queryPathname)) {
      setInitializedRoutes((prev) => [...prev, queryPathname]);
    }
    setLoading(false);
  }, [user, queryPathname, initializedRoutes]);

  const route = (route: string, Component: FC) => {
    const isVisible = queryPathname === route;
    const isInitialized = initializedRoutes.includes(route);

    return isVisible || isInitialized ? (
      <div
        id={`page-${route.slice(1)}`}
        className={clsx(classes.pageContent, {
          visible: isVisible,
          invisible: !isVisible,
        })}
      >
        {isInitialized && <Component />}
      </div>
    ) : null;
  };

  return loading ? (
    <div className="report-content w-full h-full items-center">
      <div className="flex justify-center items-center h-full">
        <LoaderCircle size={32} className="animate-spin" />
      </div>
    </div>
  ) : (
    <div className={classes.page}>
      {route("/transactions", Transactions)}
      {route("/invoices", Invoices)}
      {route("/statements", Statements)}
      {route("/accounts", Accounts)}
      {route("/reports", Reports)}
      {route("/uploads", Uploads)}
    </div>
  );
}
